/**
 * Reference documents of the IoT commissioning checks (IBM-1045), keyed by
 * the attribute index of the backend form (`iotBoxInstalled`,
 * `sensorsInstalled`, `cablesConnected`, `iotBoxConnected`,
 * `endToEndValidated`). A check without an entry shows no documents; an
 * entry without `url` shows the document number only, with `url` the chip
 * opens the PDF in a new tab.
 *
 * The PDFs live in the file service under `/file/auth/sla/` (same origin; the
 * dev server proxies `/file` to testing). That path answers 401 without the
 * user's JWT in the `Authorization` header, so the chips fetch them through
 * useAuthenticatedFileOpen instead of linking to them.
 */
export interface CommissioningDocument {
    /** Document number; shown as "Document # {{number}}" only when there is no label. */
    number: string;
    label?: string;
    url?: string;
}

const slaFileUrl = (fileName: string) => `/file/auth/sla/${encodeURIComponent(fileName)}`;

const INSTRUCTION_MANUAL: CommissioningDocument = {
    number: '0870236702',
    label: 'IoT Box instruction manual',
    url: slaFileUrl('Instruction Manual OTTO IoT Box_A0_EN_en.pdf'),
};
const CONVERSION_KITS: CommissioningDocument = {
    number: '2000185317',
    label: 'Conversion and retrofit kits',
    url: slaFileUrl('OTTO IoT Box Conversion Kits_A5_EN_en.pdf'),
};
const ELECTRICAL_SCHEMATIC: CommissioningDocument = {
    number: 'T579242726',
    label: 'Electrical schematic',
    url: slaFileUrl('T579242726_WD_E.pdf'),
};

export const IOT_COMMISSIONING_DOCUMENTS: Record<string, CommissioningDocument[] | undefined> = {
    iotBoxInstalled: [INSTRUCTION_MANUAL, CONVERSION_KITS],
    sensorsInstalled: [CONVERSION_KITS],
    cablesConnected: [CONVERSION_KITS, ELECTRICAL_SCHEMATIC],
    iotBoxConnected: [INSTRUCTION_MANUAL],
};
